var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.651,
    height: 40.651,
    viewBox: "0 0 40.651 40.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "success-icon",
    d: "M40.651,20.826a20.245,20.245,0,0,1-3.444,11.283,1.588,1.588,0,0,1-2.64-1.765,17.107,17.107,0,0,0,2.368-13.807,1.588,1.588,0,0,1,3.076-.792A20.4,20.4,0,0,1,40.651,20.826ZM29.2,35.506a17.15,17.15,0,1,1,.865-28.8,1.588,1.588,0,1,0,1.805-2.613A20.327,20.327,0,0,0,5.953,35.2a20.333,20.333,0,0,0,24.889,3.024A1.588,1.588,0,1,0,29.2,35.506ZM20.479,25.43a.905.905,0,0,1-.669-.253l-8.317-7.885a1.588,1.588,0,1,0-2.185,2.3l8.315,7.884a4.055,4.055,0,0,0,2.814,1.126c.056,0,.113,0,.169,0a4.059,4.059,0,0,0,2.883-1.359c.019-.021.037-.042.055-.064L40.3,6.338a1.588,1.588,0,0,0-2.475-1.99L21.1,25.149A.908.908,0,0,1,20.479,25.43Zm0,0",
    transform: "translate(0 -0.5)",
    fill: "#68a360"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/TickIcon.e87b02ab.svg";
export { ForwardRef as ReactComponent };